import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WikiService } from '../../../widgets/wiki/services/wiki.service';
import { FileTypeService } from '../../tracker/services/file-type.service';

@Component({
    selector: 'wiki-attachment-picker-modal',
    template: require('./wiki.attachment-picker-modal.component.html')
})
export class WikiAttachmentPickerModalComponent implements OnInit {
    @Input() wikiPageId: number;
    @Input() stagedFiles: any[] = [];

    files: any[] = [];
    loading: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private wikiService: WikiService,
        private fileTypeService: FileTypeService
    ) {}

    ngOnInit(): void {
        if (!this.wikiPageId) {
            this.files = this.stagedFiles;
            return;
        }
        this.loading = true;
        this.wikiService.getAttachments(this.wikiPageId)
            .then((response: any) => {
                const saved = (response && response.items) ? response.items : [];
                const stagedUrls = new Set(this.stagedFiles.map((f: any) => f.attachmentUrl));
                this.files = [
                    ...this.stagedFiles,
                    ...saved.filter((f: any) => !stagedUrls.has(f.attachmentUrl)),
                ];
                this.loading = false;
            })
            .catch(() => { this.loading = false; });
    }

    select(file: any): void {
        this.activeModal.close(file);
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }

    isImage(file: any): boolean { return this.fileTypeService.isImage(file); }
    formatFileSize(bytes: number): string { return this.fileTypeService.formatFileSize(bytes); }
}
